import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import styled from "styled-components";
import { Button, Modal } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

const PDFDocumentWrapper = styled.div`
  canvas {
    width: 100% !important;
    height: auto !important;
  }
`;

/**
 * 
 * @param {show} props bool for showing/hidding modal
 * @param {file} props base64 string file
 * 
 * @returns Modal
 */
const PdfModal = (props) => {

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }

    const changePage = (offset) => {
        setPageNumber(prevPageNumber => prevPageNumber + offset);
    }

    const previousPage = () => {
        changePage(-1);
    }

    const nextPage = () => {
        changePage(1);
    }

    return (
        <Modal size="lg" show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton>

            </Modal.Header>
            <Modal.Body style={{paddingTop: 0}}>
                <PDFDocumentWrapper>
                    <Document file={`data:application/pdf;base64,${props.file}`} onLoadSuccess={onDocumentLoadSuccess}>
                        <Page pageNumber={pageNumber} renderAnnotationLayer={false} />
                    </Document>
                </PDFDocumentWrapper>
                <div className="text-center">
                    <p>
                        Seite {pageNumber || (numPages ? 1 : '--')} von {numPages || '--'}
                    </p>
                    <Button
                        style={{marginRight: "5px", zIndex: 2}}
                        disabled={pageNumber <= 1}
                        onClick={previousPage}
                        className="btn-energo"
                    >
                        <FaChevronLeft />
                    </Button>
                    <Button
                        style={{zIndex: 2}}
                        disabled={pageNumber >= numPages}
                        onClick={nextPage}
                        className="btn-energo"
                    >
                        <FaChevronRight />        
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PdfModal;